import _ from 'lodash'
import { FETCH_CLIENT_ADMINS } from '../actions/types'

export default (state = [], action) => {
  switch (action.type) {
    case FETCH_CLIENT_ADMINS:
      return action.payload
    default:
      return state
  }
}
